export default class CPFValidator {
  static joiValidate(cpf, helper) {
    if (CPFValidator.validate(cpf))
      return cpf
    return helper.message('Invalid CPF.')
  }

  static validate(cpf) {
    if (!cpf || typeof cpf !== 'string')
      return false

    if (cpf.length !== 11 || !cpf.match(/^[0-9]*$/))
      return false

    const digits = cpf.split('')

    if (digits.every(d => digits[0] === d))
      return false

    if (!CPFValidator._validateFirstVerificationDigit(digits))
      return false

    if (!CPFValidator._validateSecondVerificationDigit(digits))
      return false

    return true
  }

  static cleanCPF(cpf) {
    return cpf.replace(/\.|-|\s|\//g, '')
  }

  static _validateFirstVerificationDigit(digits) {
    const mod = CPFValidator._mod(digits, 8, 10)
    return CPFValidator._validateVerificationDigit(mod, digits[9])
  }

  static _validateSecondVerificationDigit(digits) {
    const mod = CPFValidator._mod(digits, 9, 11)
    return CPFValidator._validateVerificationDigit(mod, digits[10])
  }

  static _validateVerificationDigit(mod, digit) {
    return (mod < 2 && Number(digit) === 0) || (11 - mod) === Number(digit)
  }

  static _mod(digits, sumUntil = 8, startMultiply = 10) {
    let sum = 0

    for (let i = 0; i <= sumUntil; i++)
      sum += Number(digits[i]) * (startMultiply - i)

    return sum % 11
  }
}
